import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import TimeslotPopover from "../timeslot-popover/timeslot-popover";
import moment from "moment";
import util from "../util/util";

export default function ScheduleByTimeslotSchedule(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover">
        <colgroup>
          <col style={{ width: `15%` }}></col>
          <col style={{ width: `85%` }}></col>
        </colgroup>
        <thead>
          <tr>
            <th>Day</th>
            <th>Pod</th>
          </tr>
        </thead>
        <tbody>
          {props.schedule.map((day, index) => (
            <tr key={index}>
              <th>
                <Link to={util.returnScheduleDayUrl(day.date)}>
                  {moment(day.date).format(util.dateFormatHumanShort)}
                </Link>
              </th>
              <td>
                {day.pod ? (
                  <TimeslotPopover pod={day.pod} rule={day.rule} />
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ScheduleByTimeslotSchedule.propTypes = {
  schedule: PropTypes.array // array used to build the TABLE;
};
